export const aboutPage = () => `
  <section class="page-content">
    <div class="container">
      <h1 class="page-title">Hakkımızda</h1>

      <div class="about-content">
        <p><strong>YILDIZ360</strong>, Egehan Sig Orta Aracılık Hizmetleri Ltd. Şti. tescilli ticari markasıdır. Bağımsız sigorta acentesi olarak birden fazla sigorta şirketi ile çalışıyor ve müşterilerimize en uygun sigorta çözümlerini sunuyoruz.</p>

        <p>İzmir Karşıyaka merkezli firmamız, sigorta sektöründeki deneyimi ve uzmanlığı ile müşterilerine güvenilir, hızlı ve şeffaf hizmet vermektedir. Araç sigortasından sağlık sigortasına, konut sigortasından tarım sigortasına kadar geniş bir yelpazede hizmet sunmaktayız.</p>

        <div class="about-card founder-card">
          <h2 class="section-title">Kurucumuz</h2>
          <h3>Orhan Yıldız</h3>
          <p>Sigorta sektöründe uzmanlaşmış, güçlü bir akademik altyapıya sahip profesyonel.</p>
          <div class="education-list">
            <h4>Eğitim Bilgileri</h4>
            <ul>
              <li><strong>Lise:</strong> Ticaret Meslek Lisesi</li>
              <li><strong>Ön Lisans:</strong> Ege Üniversitesi — Muhasebe</li>
              <li><strong>Lisans:</strong> Anadolu Üniversitesi — İşletme</li>
              <li><strong>Yüksek Lisans:</strong> Katip Çelebi Üniversitesi — Sosyal Bilimler Enstitüsü, İşletme</li>
            </ul>
          </div>
        </div>

        <h2 class="section-title">Sigorta Acentesi Nedir?</h2>

        <p>Sigorta acentesi, sigorta şirketleri ile müşteriler arasında aracılık yapan yetkili kişi veya işletmedir. Bir veya birden fazla sigorta şirketi adına poliçe satan, müşteriye bilgi veren ve işlemleri yürüten aracı kurumdur.</p>

        <p>YILDIZ360 olarak <strong>bağımsız acente</strong> statüsünde faaliyet gösteriyoruz — birden fazla sigorta şirketinden teklif alarak sizin için en uygun poliçeyi belirliyoruz.</p>

        <h2 class="section-title">Neler Yapıyoruz?</h2>

        <ul class="features-list">
          <li>
            <strong>Uygun Sigorta Ürünü Sunma:</strong> İhtiyaçlarınıza göre farklı şirketlerden teklif alıyor, en uygun poliçeyi belirliyoruz.
          </li>
          <li>
            <strong>Poliçe Düzenleme:</strong> Trafik, kasko, sağlık, konut, tarım ve daha birçok branşta poliçe düzenliyoruz.
          </li>
          <li>
            <strong>Hasar Desteği:</strong> Hasar durumunda müşterilerimize rehberlik ediyor, sürecin hızlı yönetilmesini sağlıyoruz.
          </li>
          <li>
            <strong>Yenileme Takibi:</strong> Poliçe bitiş tarihlerini takip ediyor, zamanında yenileme yaparak kesintisiz koruma sağlıyoruz.
          </li>
          <li>
            <strong>Fiyat Karşılaştırması:</strong> 20+ anlaşmalı sigorta şirketinden karşılaştırmalı teklif sunarak en uygun fiyatı buluyoruz.
          </li>
          <li>
            <strong>Ücretsiz Hasar Danışmanlığı:</strong> Hasar süreçleri ve araç değer kaybı konusunda ücretsiz danışmanlık hizmeti veriyoruz.
          </li>
        </ul>

        <div class="about-card legal-card">
          <h2 class="section-title">Firma Bilgileri</h2>
          <div class="legal-info">
            <p><strong>Ticari Ünvan:</strong> Egehan Sig Orta Aracılık Hizmetleri Ltd. Şti.</p>
            <p><strong>Marka:</strong> YILDIZ360</p>
            <p><strong>Vergi No:</strong> 3251134116</p>
            <p><strong>Levha No:</strong> G08612-F9BY</p>
            <p><strong>TP Sicil No:</strong> 202504450</p>
            <p><strong>Adres:</strong> Bahariye Zübeyde Hanım Cad. Karşıyaka No:26/A, İZMİR</p>
            <p><strong>Telefon:</strong> 0536 894 96 36</p>
            <p><strong>E-posta:</strong> info@yildiz360.com</p>
          </div>
        </div>
      </div>
    </div>
  </section>
`;
